module.exports = __webpack_public_path__ + "img/icn_converted_to_pn_active.f085f690.svg";